import { useAuth } from '@/shared/providers/Auth'
import useMetaEventMutation from 'app/school/queries/useMetaEventMutation'
import { SHA256 } from 'crypto-js'
import { useSearchParams } from 'next/navigation'
import { useCallback, useMemo } from 'react'

const useMetaApi = (eventName: string) => {
  const { profile } = useAuth()
  const metaMutate = useMetaEventMutation()
  const searchParams = useSearchParams()
  const fbclid = searchParams.get('fbclid')

  const fbc = useMemo(() => {
    const calculateSubdomainIndex = (hostname: string) => {
      const parts = hostname.split('.')
      return parts.length // com = 1, example.com = 2, www.example.com = 3 
    }

    const now = Date.now()
    const hostname = window.location.hostname
    const subdomainIndex = calculateSubdomainIndex(hostname)
    // fbclid는 페이스북 광고를 통해서 들어오면 params로 들어옴
    return fbclid ? `fb.${subdomainIndex}.${now}.${fbclid}` : null
  }, [fbclid])

  const onMetaEvent = useCallback(async () => {
    if (profile) {
      // IP 주소를 가져오기 위한 API 호출
      const { publicIpv4 } = await import('public-ip')
      const userIp = await publicIpv4()

      metaMutate.mutate({
        event_name: eventName,
        event_time: Math.floor(Date.now() / 1000),
        data: [
          {
            event_name: eventName,
            event_time: Math.floor(Date.now() / 1000),
            user_data: {
              em: SHA256(profile?.email).toString(),
              ph: SHA256(profile?.phoneNo).toString(),
              client_ip_address: userIp,
              client_user_agent: navigator.userAgent,
              fbc: fbc,
              ge: profile?.gender ? SHA256(profile.gender.split(' ')[0]).toString() : '',
              fn: profile?.name ? SHA256(profile.name).toString() : '',
            },
          },
        ],
      })
    }
  }, [profile])

  return { onMetaEvent }
}

export default useMetaApi
